import React, { useCallback, useReducer } from 'react';
import { CopyMenuModalActionTypes } from '../copyMenuModalActions';
import { copyMenuModalReducer } from './copyMenuModalReducer';
import { copyMenuModalInitialState, CopyMenuModalContext, TTypeOfCopyMenuModalWindow } from './copyMenuModalContext';

const CopyMenuModalState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(copyMenuModalReducer, copyMenuModalInitialState);

	const setIDsRestaurantsToCopyMenu = (value: string[]) => {
		dispatch({
			type: CopyMenuModalActionTypes.SET_IDS_RESTAURANTS_TO_COPY_MENU,
			payload: {
				IDsSelectedRestaurantsToCopyMenu: value,
			},
		});
	};

	const changeTypeOfCopyMenuModalWindow = useCallback((value: TTypeOfCopyMenuModalWindow) => {
		dispatch({
			type: CopyMenuModalActionTypes.CHANGE_TYPE_OF_COPY_MENU_MODAL_WINDOW,
			payload: {
				typeOfCopyMenuModalWindow: value,
			},
		});
	}, []);

	return (
		<CopyMenuModalContext.Provider
			value={{
				setIDsRestaurantsToCopyMenu,
				changeTypeOfCopyMenuModalWindow,
				IDsSelectedRestaurantsToCopyMenu: state.IDsSelectedRestaurantsToCopyMenu,
				typeOfCopyMenuModalWindow: state.typeOfCopyMenuModalWindow,
			}}>
			{children}
		</CopyMenuModalContext.Provider>
	);
};

export default React.memo(CopyMenuModalState);
